import { useState } from 'react'
import { FaAngleDown, FaAngleUp, FaClone, FaEdit, FaMinusCircle } from 'react-icons/fa'
import { CircuitRow, Table, TableContainer, Td, Th, Tr } from './styles'

export function getCircuitPower(circuit) {
  return (circuit.elements || []).reduce((total, element) => total + element.quantity * element.electricPower, 0)
}

// Tabela somente de leitura: a edição acontece no modal. As linhas podem ser arrastadas; os botões de seta são a
// alternativa por teclado.
export function CircuitsTable({ circuits, idrs, demandRules, invalidIds, onEdit, onDuplicate, onRemove, onMove }) {
  const [dragIndex, setDragIndex] = useState(null)
  const [overIndex, setOverIndex] = useState(null)

  function endDrag() {
    setDragIndex(null)
    setOverIndex(null)
  }

  function handleDrop(event, index) {
    event.preventDefault()
    if (dragIndex !== null && dragIndex !== index) onMove(dragIndex, index)
    endDrag()
  }

  if (circuits.length < 1) return <p>Nenhum circuito inserido</p>

  return (
    <TableContainer>
      <Table style={{ marginTop: '12px' }}>
        <thead>
          <Tr>
            <Th>Nº</Th>
            <Th>Nome</Th>
            <Th>Potência (VA)</Th>
            <Th>Regra de demanda</Th>
            <Th>IDR</Th>
            <Th>Ações</Th>
          </Tr>
        </thead>
        <tbody>
          {circuits.map((circuit, index) => (
            <CircuitRow
              key={circuit.id}
              draggable
              $invalid={invalidIds.has(circuit.id)}
              $dragOver={overIndex === index && dragIndex !== null && dragIndex !== index}
              onDragStart={(event) => {
                event.dataTransfer.effectAllowed = 'move'
                setDragIndex(index)
              }}
              onDragOver={(event) => {
                event.preventDefault()
                setOverIndex(index)
              }}
              onDrop={(event) => handleDrop(event, index)}
              onDragEnd={endDrag}
            >
              <Td>{circuit.id}</Td>
              <Td>{circuit.name || <em>Sem nome</em>}</Td>
              <Td>{getCircuitPower(circuit)}</Td>
              <Td>{demandRules.find((rule) => rule.id === circuit.demandRuleId)?.name || '-'}</Td>
              <Td>{idrs.find((idr) => idr.id === circuit.idrId)?.id || '-'}</Td>
              <Td style={{ whiteSpace: 'nowrap' }}>
                <button
                  type="button"
                  title="Editar circuito"
                  aria-label="Editar circuito"
                  onClick={() => onEdit(index)}
                >
                  <FaEdit />
                </button>{' '}
                <button
                  type="button"
                  title="Duplicar circuito"
                  aria-label="Duplicar circuito"
                  onClick={() => onDuplicate(index)}
                >
                  <FaClone />
                </button>{' '}
                <button
                  type="button"
                  title="Remover circuito"
                  aria-label="Remover circuito"
                  onClick={() => onRemove(index)}
                >
                  <FaMinusCircle />
                </button>{' '}
                <button
                  type="button"
                  title="Mover para cima"
                  aria-label="Mover para cima"
                  disabled={index === 0}
                  onClick={() => onMove(index, index - 1)}
                >
                  <FaAngleUp />
                </button>
                <button
                  type="button"
                  title="Mover para baixo"
                  aria-label="Mover para baixo"
                  disabled={index === circuits.length - 1}
                  onClick={() => onMove(index, index + 1)}
                >
                  <FaAngleDown />
                </button>
              </Td>
            </CircuitRow>
          ))}
        </tbody>
      </Table>
    </TableContainer>
  )
}
